import { PaymentMethodsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/payment-methods')({
  component: PaymentMethodsRoute,
});
